import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import { SizeVariantSelectionButton } from './size-variant-selection-button';
import { IVariantsProps, IVariantValue } from '../types';
import { getGroupedVariants } from './size-variant-utils';
import {
  VariantGridWrapper,
  VariantGridTitle,
  VariantGridCell,
  VariantGridHeader,
  ScrollableArea,
} from '../styles';

export const SizeVariantsGrid: React.FC<IVariantsProps> = props => {
  const { title, variants, handleSelection } = props;
  const { t } = useAppContext();

  const groupedVariants = getGroupedVariants(variants?.sizes.filter(Boolean));

  const selectAllCell = (
    <VariantGridCell>
      <SizeVariantSelectionButton
        handleSelection={handleSelection}
        title={t('product', 'variants.all')}
        variant={null}
      />
    </VariantGridCell>
  );

  const variantGroupCells = (
    i: number,
    variantGroup: IVariantValue[],
    showSelectAll: boolean
  ) => (
    <VariantGridWrapper key={i}>
      {showSelectAll && selectAllCell}
      {variantGroup.map(sizeVariant => (
        <VariantGridCell key={sizeVariant.size}>
          <SizeVariantSelectionButton
            handleSelection={handleSelection}
            title={sizeVariant.size!}
            variant={sizeVariant.size!}
            disabled={sizeVariant.disabled}
          />
        </VariantGridCell>
      ))}
    </VariantGridWrapper>
  );

  return (
    <div>
      {title && (
        <VariantGridHeader>
          <VariantGridTitle>
            <TitleMediumText>{title}</TitleMediumText>
          </VariantGridTitle>
        </VariantGridHeader>
      )}
      <ScrollableArea>
        {groupedVariants.map((group, i) =>
          variantGroupCells(i, group, i === 0)
        )}
      </ScrollableArea>
    </div>
  );
};
